import { useCallback, useLayoutEffect, useReducer, useRef } from 'react';
/** A send requests one scroll after its new message is committed, never continuous stream following. */
export class SendScrollController {
    pendingScope;
    request(scope) {
        this.pendingScope = scope;
    }
    flush(scope, target) {
        const pending = this.pendingScope;
        // Consume even if the view closed or changed. A later render must not revive an old request.
        this.pendingScope = undefined;
        if (pending === undefined || pending !== scope || !target?.isConnected)
            return false;
        target.scrollTo({ top: target.scrollHeight, behavior: 'instant' });
        return true;
    }
}
/** Call the returned function only AFTER a send passes validation and appends the user message. */
export function useSendScroll({ targetRef, enabled, scope }) {
    const controller = useRef(new SendScrollController());
    const [requestVersion, requestCommit] = useReducer((version) => version + 1, 0);
    useLayoutEffect(() => {
        controller.current.flush(scope, enabled ? targetRef.current : null);
    }, [requestVersion, enabled, scope, targetRef]);
    return useCallback(() => {
        if (!enabled)
            return;
        controller.current.request(scope);
        requestCommit();
    }, [enabled, scope]);
}
//# sourceMappingURL=useSendScroll.js.map